import { render, staticRenderFns } from "./ListLicenseVerifications.vue?vue&type=template&id=2798c981&"
import script from "./ListLicenseVerifications.vue?vue&type=script&lang=js&"
export * from "./ListLicenseVerifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports